// Schema-driven flow definition for /welcome
// Each step has: id, type, promptKey (i18n), options (for choices), and next resolver
// Supported types: system, singleChoice, multiChoice, text

import { UnitOccupationList } from "../../../Utils/constants";

// Neighborhood data mapped by market code
const NEIGHBORHOODS_BY_MARKET = {
  AUS: [
    "Barton Hills",
    "Bastrop",
    "Buda & Kyle",
    "Cedar Park",
    "Central",
    "Clarksville",
    "Decker",
    "Domain",
    "Downtown",
    "East",
    "East Riverside / Oltorf",
    "Far Northeast",
    "Georgetown",
    "Hutto",
    "Kyle",
    "Lake Travis",
    "Lake Travis North",
    "Lake Travis South",
    "Leander",
    "Liberty Hill",
    "Manor",
    "Marble Falls",
    "Menchaca",
    "Mueller",
    "North",
    "Northeast",
    "Northwest",
    "Northwest Hills",
    "Pflugerville",
    "Round Rock",
    "San Marcos",
    "South",
    "South Central",
    "Southeast",
    "Southwest",
    "Tarrytown",
    "Taylor",
    "Westlake"
  ],
  DFW: [
    "Arlington",
    "Arlington - East",
    "Arlington - North",
    "Arlington - South",
    "Bishop Arts District",
    "Dallas - Anna",
    "Dallas - Deep Ellum",
    "Dallas - Downtown",
    "Dallas - East",
    "Dallas - Far North",
    "Dallas - Far South",
    "Dallas - Highland Park/Park Cities",
    "Dallas - Kessler/Bishop Arts",
    "Dallas - Knox/Henderson",
    "Dallas - Medical/Design Districts",
    "Dallas - Midtown",
    "Dallas - North",
    "Dallas - North Central",
    "Dallas - Northeast / Vickery Meadow",
    "Dallas - Northwest",
    "Dallas - Old East Dallas",
    "Dallas - South",
    "Dallas - Southeast",
    "Dallas - Southwest",
    "Dallas - Uptown",
    "Dallas - West Dallas / Trinity Groves",
    "Dallas Surrounding - Addison",
    "Dallas Surrounding - Allen/McKinney",
    "Dallas Surrounding - Carrollton and Farmers Branch",
    "Dallas Surrounding - Crandell",
    "Dallas Surrounding - Denison",
    "Dallas Surrounding - DeSoto",
    "Dallas Surrounding - Duncanville/Cedar Hill",
    "Dallas Surrounding - Fate",
    "Dallas Surrounding - Forney/Terrell/Kaufman",
    "Dallas Surrounding - Frisco",
    "Dallas Surrounding - Garland",
    "Dallas Surrounding - Grayson County",
    "Dallas Surrounding - Hunt County",
    "Dallas Surrounding - Lake Highlands",
    "Dallas Surrounding - Lancaster",
    "Dallas Surrounding - Little Elm",
    "Dallas Surrounding - Mesquite and Balch Springs",
    "Dallas Surrounding - Princeton",
    "Dallas Surrounding - Prosper/Celina",
    "Dallas Surrounding - Richardson",
    "Dallas Surrounding - Rockwall County",
    "Dallas Surrounding - The Colony",
    "Dallas Surrounding - Waxahachie/Ennis",
    "Denton",
    "Denton County",
    "Downtown Arlington",
    "Downtown Rowlett",
    "East Dallas",
    "Fort Worth and Surrounding - Benbrook",
    "Fort Worth and Surrounding - Burleson/Crowley",
    "Fort Worth - Downtown",
    "Fort Worth - East",
    "Fort Worth - Granbury",
    "Fort Worth - Lake Worth",
    "Fort Worth - North",
    "Fort Worth - Northlake",
    "Fort Worth - Northwest",
    "Fort Worth - Roanoke",
    "Fort Worth - South",
    "Fort Worth - Southeast",
    "Fort Worth - Southwest",
    "Fort Worth - West",
    "Fort Worth Surrounding - Johnson County",
    "Fort Worth Surrounding - Parker County",
    "Fort Worth Surrounding - Tarrant County",
    "Garland",
    "Glenview/Singing Hills",
    "Grand Prairie",
    "Grapevine",
    "Grapevine Mills",
    "Greater Mesquite",
    "Heritage",
    "Irving",
    "Irving - Las Colinas",
    "Irving - Valley Ranch",
    "Kessler",
    "Kiest Park",
    "Knox Henderson",
    "La Bajada/Trinity Groves",
    "Lake Highlands",
    "Las Colinas",
    "Lavon",
    "Lewisville/Flower Mound",
    "Love Field",
    "Medical District",
    "Melissa",
    "Middle Cities - Bedford",
    "Middle Cities - Coppell",
    "Middle Cities - Corinth",
    "Middle Cities - Euless",
    "Middle Cities - Grand Prairie",
    "Middle Cities - Grapevine",
    "Middle Cities - Hickory Creek",
    "Middle Cities - Hurst/Euless/Bedford",
    "Middle Cities - Lewisville and Flower Mound",
    "Middle Cities - Mansfield",
    "Middle Cities.- Midlothian",
    "Middle Cities - North Richland Hills/Haltom City",
    "Middle Cities - Trophy Club/Keller",
    "Plano",
    "Prestonwood",
    "River District",
    "Rowlett",
    "Sachse",
    "Saginaw",
    "Sherman",
    "South Arlington",
    "Southlake",
    "Southside Medical District",
    "Temple",
    "Urban Center Irving",
    "Valley Ranch",
    "Venus",
    "Viridian",
    "West 7th",
    "West End"
  ],
  HOU: [
    "Bellaire & Medical Center",
    "Braeswood / Southwest",
    "Briar Forest",
    "Briar Village",
    "Champions",
    "Chinatown",
    "Conroe",
    "Cypress",
    "Cypress / Addicks",
    "Cypresswood",
    "Downtown",
    "Energy Corridor",
    "Far East",
    "Far North",
    "Far Northeast",
    "Far Northwest",
    "Far South",
    "Far Southeast",
    "Far Southwest",
    "Fountain Lake",
    "Galleria / Woodlake",
    "Galveston",
    "Heights",
    "Houston",
    "Inner Loop East",
    "Inner Loop West / River Oaks",
    "Inwood & Nw 290",
    "Katy",
    "Katy & Far West",
    "Kingwood",
    "Lake Houston",
    "Medical Center",
    "Medical Center South",
    "Midtown",
    "Midtown Houston",
    "Montrose",
    "Museum District",
    "Northgate Crossing",
    "Pearland",
    "Richmond / Rosenberg",
    "River Oaks",
    "South",
    "Southbelt-Ellington",
    "South Central",
    "Spring Branch",
    "Sugar Land / Missouri City",
    "Town Center",
    "Washington Ave",
    "West",
    "Woodlands"
  ],
  SAT: [
    "Alamo Heights",
    "Boerne",
    "Brackenridge Park",
    "Brooks",
    "Castle Hills Forest",
    "Downtown",
    "Downtown San Antonio",
    "East / Far East",
    "Far North",
    "Far Northeast",
    "Far Northwest",
    "Far South",
    "Far West",
    "Far West Side",
    "For Northwest",
    "Harlandale",
    "Hillcrest",
    "Hills of Park North",
    "Historic San Antonio",
    "Hot Wells",
    "Huntington Place",
    "La Cantera",
    "Live Oak Park",
    "Medical Center",
    "Mission Del Lago",
    "Monterrey Village",
    "Monticello Park",
    "New Braunfels",
    "North",
    "North Central",
    "Northeast / Alamo Heights",
    "Northeast San Antonio",
    "Northeast Side",
    "Northern Hills",
    "Northwest",
    "Northwest Side",
    "Oak Hills",
    "Port San Antonio",
    "River Walk",
    "San Antonio",
    "Shavano",
    "South Central",
    "South San Antonio",
    "Southwest",
    "Southwest Side",
    "Stone Oak",
    "Thousand Oaks",
    "Thunderbird Hills",
    "Timberwood Park",
    "Universal City / Randolph Airforce Base",
    "Uptown San Antonio",
    "UTSA",
    "Vance Jackson",
    "Walker Ranch Park",
    "West",
    "Westover Hills",
    "Westside San Antonio",
    "Woodstone"
  ]
};

// Map city IDs to market codes
const CITY_TO_MARKET = {
  dallas: "DFW",
  houston: "HOU",
  austin: "AUS",
  san_antonio: "SAT"
};

// Map city names to city IDs
const CITY_NAME_TO_ID = {
  austin: 286,
  dallas: 1010,
  houston: 1001,
  san_antonio: 1003
};

// Map neighborhood names to neighborhood IDs by city
const NEIGHBORHOOD_NAME_TO_ID = {
  austin: {
    "Barton Hills": "1326",
    "Bastrop": "16",
    "Buda & Kyle": "17",
    "Cedar Park": "18",
    "Central": "19",
    "Clarksville": "1333",
    "Decker": "1332",
    "Domain": "1055",
    "Downtown": "21",
    "East": "23",
    "East Riverside / Oltorf": "1325",
    "Far Northeast": "3626",
    "Georgetown": "26",
    "Hutto": "1084",
    "Kyle": "3659",
    "Lake Travis": "5144",
    "Lake Travis North": "1329",
    "Lake Travis South": "1327",
    "Leander": "28",
    "Liberty Hill": "5554",
    "Manor": "1062",
    "Marble Falls": "4799",
    "Menchaca": "1063",
    "Mueller": "1331",
    "North": "33",
    "Northeast": "35",
    "Northwest": "36",
    "Northwest Hills": "1328",
    "Pflugerville": "37",
    "Round Rock": "39",
    "San Marcos": "40",
    "South": "42",
    "South Central": "43",
    "Southeast": "46",
    "Southwest": "47",
    "Tarrytown": "1601",
    "Taylor": "1680",
    "Westlake": "1678"
  },
  dallas: {
    "Arlington": "5399",
    "Arlington - East": "4794",
    "Arlington - North": "1413",
    "Arlington - South": "1414",
    "Bishop Arts District": "5278",
    "Dallas - Anna": "4786",
    "Dallas - Deep Ellum": "1338",
    "Dallas - Downtown": "1335",
    "Dallas - East": "1554",
    "Dallas - Far North": "1342",
    "Dallas - Far South": "1345",
    "Dallas - Highland Park/Park Cities": "1566",
    "Dallas - Kessler/Bishop Arts": "1556",
    "Dallas - Knox/Henderson": "1595",
    "Dallas - Medical/Design Districts": "1568",
    "Dallas - Midtown": "1562",
    "Dallas - North": "1348",
    "Dallas - North Central": "1354",
    "Dallas - Northeast / Vickery Meadow": "1346",
    "Dallas - Northwest": "1355",
    "Dallas - Old East Dallas": "1339",
    "Dallas - South": "1352",
    "Dallas - Southeast": "1559",
    "Dallas - Southwest": "1353",
    "Dallas - Uptown": "1594",
    "Dallas - West Dallas / Trinity Groves": "1336",
    "Dallas Surrounding - Addison": "1428",
    "Dallas Surrounding - Allen/McKinney": "1560",
    "Dallas Surrounding - Carrollton and Farmers Branch": "1430",
    "Dallas Surrounding - Crandell": "4804",
    "Dallas Surrounding - Denison": "4810",
    "Dallas Surrounding - DeSoto": "1431",
    "Dallas Surrounding - Duncanville/Cedar Hill": "1432",
    "Dallas Surrounding - Fate": "5546",
    "Dallas Surrounding - Forney/Terrell/Kaufman": "1434",
    "Dallas Surrounding - Frisco": "1433",
    "Dallas Surrounding - Garland": "1435",
    "Dallas Surrounding - Grayson County": "1436",
    "Dallas Surrounding - Hunt County": "1437",
    "Dallas Surrounding - Lake Highlands": "1555",
    "Dallas Surrounding - Lancaster": "1569",
    "Dallas Surrounding - Little Elm": "4798",
    "Dallas Surrounding - Mesquite and Balch Springs": "1557",
    "Dallas Surrounding - Princeton": "2061",
    "Dallas Surrounding - Prosper/Celina": "1561",
    "Dallas Surrounding - Richardson": "1448",
    "Dallas Surrounding - Rockwall County": "1447",
    "Dallas Surrounding - The Colony": "1443",
    "Dallas Surrounding - Waxahachie/Ennis": "1449",
    "Denton": "3980",
    "Denton County": "1859",
    "Downtown Arlington": "5280",
    "Downtown Rowlett": "3155",
    "East Dallas": "5286",
    "Fort Worth and Surrounding - Benbrook": "1410",
    "Fort Worth and Surrounding - Burleson/Crowley": "1411",
    "Fort Worth - Downtown": "1563",
    "Fort Worth - East": "1578",
    "Fort Worth - Granbury": "1576",
    "Fort Worth - Lake Worth": "5582",
    "Fort Worth - North": "1567",
    "Fort Worth - Northlake": "5545",
    "Fort Worth - Northwest": "3449",
    "Fort Worth - Roanoke": "4805",
    "Fort Worth - South": "1446",
    "Fort Worth - Southeast": "1577",
    "Fort Worth - Southwest": "1445",
    "Fort Worth - West": "1564",
    "Fort Worth Surrounding - Johnson County": "1575",
    "Fort Worth Surrounding - Parker County": "1571",
    "Fort Worth Surrounding - Tarrant County": "1574",
    "Garland": "5260",
    "Glenview/Singing Hills": "5295",
    "Grand Prairie": "2681",
    "Grapevine": "5288",
    "Grapevine Mills": "4795",
    "Greater Mesquite": "3409",
    "Heritage": "4797",
    "Irving": "2204",
    "Irving - Las Colinas": "1570",
    "Irving - Valley Ranch": "1565",
    "Kessler": "5261",
    "Kiest Park": "5115",
    "Knox Henderson": "5257",
    "La Bajada/Trinity Groves": "5291",
    "Lake Highlands": "1927",
    "Las Colinas": "5265",
    "Lavon": "4770",
    "Lewisville/Flower Mound": "5297",
    "Love Field": "2286",
    "Medical District": "4061",
    "Melissa": "4784",
    "Middle Cities - Bedford": "1419",
    "Middle Cities - Coppell": "1415",
    "Middle Cities - Corinth": "4809",
    "Middle Cities - Euless": "1420",
    "Middle Cities - Grand Prairie": "1416",
    "Middle Cities - Grapevine": "1417",
    "Middle Cities - Hickory Creek": "4802",
    "Middle Cities - Hurst/Euless/Bedford": "1572",
    "Middle Cities - Lewisville and Flower Mound": "1421",
    "Middle Cities - Mansfield": "1424",
    "Middle Cities.- Midlothian": "3968",
    "Middle Cities - North Richland Hills/Haltom City": "1425",
    "Middle Cities - Trophy Club/Keller": "1442",
    "Plano": "646",
    "Prestonwood": "5284",
    "River District": "3447",
    "Rowlett": "4800",
    "Sachse": "4806",
    "Saginaw": "5556",
    "Sherman": "5539",
    "South Arlington": "5254",
    "Southlake": "5559",
    "Southside Medical District": "5287",
    "Temple": "5558",
    "Urban Center Irving": "5253",
    "Valley Ranch": "1597",
    "Venus": "5322",
    "Viridian": "3429",
    "West 7th": "3450",
    "West End": "5294"
  },
  houston: {
    "Bellaire & Medical Center": "56",
    "Braeswood / Southwest": "1302",
    "Briar Forest": "5565",
    "Briar Village": "5576",
    "Champions": "59",
    "Chinatown": "1307",
    "Conroe": "2856",
    "Cypress": "5569",
    "Cypress / Addicks": "1301",
    "Cypresswood": "5578",
    "Downtown": "1314",
    "Energy Corridor": "5543",
    "Far East": "65",
    "Far North": "1304",
    "Far Northeast": "1310",
    "Far Northwest": "1116",
    "Far South": "1300",
    "Far Southeast": "1117",
    "Far Southwest": "1309",
    "Fountain Lake": "5567",
    "Galleria / Woodlake": "1305",
    "Galveston": "5563",
    "Heights": "1306",
    "Houston": "5566",
    "Inner Loop East": "73",
    "Inner Loop West / River Oaks": "1297",
    "Inwood & Nw 290": "75",
    "Katy": "5568",
    "Katy & Far West": "76",
    "Kingwood": "5579",
    "Lake Houston": "5572",
    "Medical Center": "5034",
    "Medical Center South": "5577",
    "Midtown": "1295",
    "Midtown Houston": "5564",
    "Montrose": "1296",
    "Museum District": "1311",
    "Northgate Crossing": "5575",
    "Pearland": "5583",
    "Richmond / Rosenberg": "1308",
    "River Oaks": "5571",
    "South": "1299",
    "Southbelt-Ellington": "5574",
    "South Central": "1840",
    "Spring Branch": "89",
    "Sugar Land / Missouri City": "1298",
    "Town Center": "5570",
    "Washington Ave": "1313",
    "West": "1303",
    "Woodlands": "97"
  },
  san_antonio: {
    "Alamo Heights": "2348",
    "Boerne": "1610",
    "Brackenridge Park": "1929",
    "Brooks": "4661",
    "Castle Hills Forest": "4093",
    "Downtown": "494",
    "Downtown San Antonio": "3977",
    "East / Far East": "1315",
    "Far North": "498",
    "Far Northeast": "508",
    "Far Northwest": "500",
    "Far South": "1321",
    "Far West": "1323",
    "Far West Side": "1733",
    "For Northwest": "503",
    "Harlandale": "4094",
    "Hillcrest": "5356",
    "Hills of Park North": "3935",
    "Historic San Antonio": "5353",
    "Hot Wells": "3956",
    "Huntington Place": "3887",
    "La Cantera": "5357",
    "Live Oak Park": "5365",
    "Medical Center": "505",
    "Mission Del Lago": "5371",
    "Monterrey Village": "3267",
    "Monticello Park": "5354",
    "New Braunfels": "506",
    "North": "495",
    "North Central": "515",
    "Northeast / Alamo Heights": "1317",
    "Northeast San Antonio": "2347",
    "Northeast Side": "2058",
    "Northern Hills": "5368",
    "Northwest": "510",
    "Northwest Side": "2353",
    "Oak Hills": "1938",
    "Port San Antonio": "4627",
    "River Walk": "5367",
    "San Antonio": "2350",
    "Shavano": "5358",
    "South Central": "1318",
    "South San Antonio": "2352",
    "Southwest": "1322",
    "Southwest Side": "1930",
    "Stone Oak": "5370",
    "Thousand Oaks": "2027",
    "Thunderbird Hills": "5360",
    "Timberwood Park": "5355",
    "Universal City / Randolph Airforce Base": "1320",
    "Uptown San Antonio": "5369",
    "UTSA": "1316",
    "Vance Jackson": "5361",
    "Walker Ranch Park": "5359",
    "West": "507",
    "Westover Hills": "1990",
    "Westside San Antonio": "2351",
    "Woodstone": "5372"
  }
};

// Export mappings for use in other files
export { CITY_NAME_TO_ID, NEIGHBORHOOD_NAME_TO_ID };

export const STEP_IDS = {
  GLOBAL_GREET: "Global0_Greet",
  GLOBAL_PERSONA: "Global1_UseCase",
  RENTER_INTENT: "Renter1A_FindHomeIntent",
  RENTER_MOVING_CONCIERGE: "Renter1B_MovingConcierge",
  RENTER_MOVING_SOON_INTRO: "Renter1C_MovingSoonIntro",
  RENTER_MOVING_DEALS: "Renter1D_MovingDeals",
  RENTER_MOVING_RENTERS_INSURANCE: "Renter1E_MovingRentersInsurance",
  RENTER_FIND_HOME_CONSENT: "Renter2A_FindHomeConsent",
  RENTER_BUDGET: "Renter2B_FindHomeBudget",
  RENTER_MOVE_IN: "Renter2C_MoveInDate",
  RENTER_MOVE_IN_IMPORTANCE: "Renter2C1_MoveInImportance",
  RENTER_LEASE_SIGNERS: "Renter2C2_LeaseSigners",
  RENTER_TARGET_CITY: "Renter2D_TargetCity",
  RENTER_NEIGHBORHOODS: "Renter2D1_Neighborhoods",
  RENTER_BEDROOMS: "Renter2E_Bedrooms",
  RENTER_NAME_EMAIL: "Renter2E1_NameEmail",
  RENTER_PETS: "Renter2F_Pets",
  RENTER_AMENITIES: "Renter2F1_Amenities",
  RENTER_PARKING: "Renter2F2_Parking",
  RENTER_WHAT_MATTERS: "Renter2F3_WhatMatters",
  RENTER_HOME_TYPE: "Renter2G_HomeType",
  RENTER_CREDIT_SCORE: "Renter2H_CreditScore",
  RENTER_CONTACT_CONSENT: "Renter3A_ContactConsent",
  RENTER_CONTACT_SELLDOWN: "Renter3B_ContactSellDown",
  RENTER_CONTACT_METHOD: "Renter3C_ContactMethod",
  RENTER_PHONE_CALL: "Renter3D_PhoneCall",
  RENTER_PHONE_TEXT: "Renter3E_PhoneText",
  RENTER_EMAIL: "Renter3F_Email",
  RENTER_FIND_HOME_INTRO: "Renter4_FindHomeIntro",
  RENTER_FIND_HOME_FINAL: "Renter5_FindHomeFinal",
  CASHBACK_INTRO: "Cashback0_Intro",
  CREDIT_INTRO: "Credit0_Intro",
  GLOBAL_TRUST: "Global2_Trust",
  GLOBAL_IDENTITY: "Global3_Identity",
  GLOBAL_MANUAL_CONTACT: "Global3A_ManualContact",
  GLOBAL_POST_IDENTITY_ROUTER: "Global4_PostIdentityRouter",
  GLOBAL_POST_IDENTITY_GREETING: "Global4A_PostIdentityGreeting",
  GLOBAL_DOB_CHECK: "Global4B_DOBCheck",
  RETURNING_USER_GREETING: "ReturningUser1_Greeting",
  AGENT_CONTACT_COMPLETE: "Agent2_ContactComplete",
  GLOBAL_END: "Global999_End",
  CASHBACK_WHERE_PAY_RENT: "Cashback1_WherePayRent",
  CASHBACK_HOW_PAY_RENT: "Cashback1A_HowPayRent",
  CASHBACK_METHOD_PROMPT: "Cashback1B_MethodPrompt",
  CASHBACK_READY: "Cashback1C_ReadyToJoin",
  CASHBACK_ACCOUNT_EXPLAINER: "Cashback1C_AccountExplainer",
  CASHBACK_ACCOUNT_WHY: "Cashback1D_Why",
  CASHBACK_ACCOUNT_SELLDOWN: "Cashback1E_AccountSellDown",
  CASHBACK_READY_SELLDOWN: "Cashback1F_ReadySellDown",
  CASHBACK_READY_WHY: "Cashback1G_ReadyWhy",
  CASHBACK_PHONE_COLLECTION: "Cashback2_PhoneCollection",
  CASHBACK_PHONE_INPUT: "Cashback2A_PhoneInput",
  CASHBACK_PHONE_THANKS: "Cashback2B_PhoneThanks",
  CASHBACK_BANK_OCCUPATION: "Cashback3A_BankOccupation",
  CASHBACK_BANK_ADDRESS: "Cashback3B_BankAddress",
  CASHBACK_BANK_DOB: "Cashback3C_BankDOB",
  CASHBACK_BANK_SSN: "Cashback3D_BankSSN",
  CASHBACK_BANK_PRICING: "Cashback3E_BankPricing",
  CASHBACK_BANK_DISCLOSURES: "Cashback3F_BankDisclosures",
  CASHBACK_BANK_FINAL: "Cashback3G_BankFinal",
  CASHBACK_2FA_REQUEST: "Cashback3H_2FARequest",
  CASHBACK_2FA_VERIFY: "Cashback3I_2FAVerify",
  CASHBACK_METHOD_FOLLOWUP: "Cashback4_MethodFollowup",
  CREDIT_METHOD_FOLLOWUP: "Credit1_MethodFollowup",
  AGENT_TRUST: "Agent1_Trust",
  OWNER_TRUST: "Owner1_Trust",
  OWNER_MOM_POP_TRUST: "Owner2_MomPopTrust",
  OWNER_LARGE_TRUST: "Owner3_LargeTrust",
  LEARN_TRUST: "Learn1_Trust",
  OWNER_PORTFOLIO: "Owner0_Portfolio"
};

export const WELCOME_FLOW_SCHEMA = {
  schemaVersion: "1.0.0",
  namespace: "welcome.flow",
  steps: [
    {
      id: STEP_IDS.GLOBAL_GREET,
      type: "system",
      promptKey: "greetNew",
      next: STEP_IDS.GLOBAL_PERSONA
    },
    {
      id: STEP_IDS.GLOBAL_PERSONA,
      type: "singleChoice",
      promptKey: "useCase.prompt",
      showPiiNotice: true,
      options: [
        {
          id: "renter_find_home",
          labelKey: "useCase.rentHome",
          next: STEP_IDS.RENTER_FIND_HOME_CONSENT,
          answerPatch: { persona: "renter", renterReasons: ["find-home"] }
        },
        {
          id: "renter_moving_soon",
          labelKey: "useCase.movingSoon",
          next: STEP_IDS.RENTER_MOVING_SOON_INTRO,
          answerPatch: { persona: "renter", renterReasons: ["moving-soon"] }
        },
        {
          id: "renter_cashback",
          labelKey: "useCase.cashback",
          next: STEP_IDS.CASHBACK_WHERE_PAY_RENT,
          answerPatch: { persona: "renter", renterReasons: ["cashback"] }
        },
        {
          id: "agent",
          labelKey: "useCase.agent",
          next: STEP_IDS.AGENT_TRUST,
          answerPatch: { persona: "agent" }
        },
        {
          id: "owner",
          labelKey: "useCase.ownRentals",
          next: STEP_IDS.OWNER_PORTFOLIO,
          answerPatch: { persona: "owner" }
        },
        {
          id: "just_learn",
          labelKey: "useCase.learn",
          next: STEP_IDS.LEARN_TRUST,
          answerPatch: { persona: "just_learn" }
        }
      ],
      answerKey: "useCase"
    },
    // Legacy multi-choice step remains defined for schema validation, but current flow routes directly based on use case selection.
    {
      id: STEP_IDS.RENTER_INTENT,
      type: "multiChoice",
      promptKey: "renter.prompt",
      options: [
        { id: "find-home", labelKey: "reasons.findHome" },
        { id: "cashback", labelKey: "reasons.cashback" },
        { id: "found-soon", labelKey: "reasons.foundSoon" },
        { id: "credit", labelKey: "reasons.credit" },
        { id: "other", labelKey: "reasons.other", isOther: true, otherPlaceholderKey: "methods.pleaseSpecify" }
      ],
      answerKey: "renterReasons",
      next: (answers) => {
        const reasons = answers?.renterReasons ?? [];
        if (reasons.includes("find-home")) return STEP_IDS.RENTER_FIND_HOME_CONSENT;
        if (reasons.includes("cashback")) return STEP_IDS.CASHBACK_WHERE_PAY_RENT;
        if (reasons.includes("found-soon")) return STEP_IDS.RENTER_MOVING_CONCIERGE;
        if (reasons.includes("credit")) return STEP_IDS.CREDIT_INTRO;
        return STEP_IDS.GLOBAL_TRUST;
      }
    },
    {
      id: STEP_IDS.OWNER_PORTFOLIO,
      type: "text",
      promptKey: "owner.portfolioPrompt",
      fields: [{ id: "portfolioSize", labelKey: "owner.portfolioField" }],
      answerKey: "ownerPortfolio",
      next: STEP_IDS.OWNER_TRUST
    },
    {
      id: STEP_IDS.RENTER_MOVING_CONCIERGE,
      type: "singleChoice",
      promptKey: "findHome.movingConciergePrompt",
      options: [
        { id: "yes", labelKey: "findHome.movingConciergeYes", next: STEP_IDS.RENTER_PHONE_TEXT },
        { id: "no", labelKey: "findHome.movingConciergeNo", next: STEP_IDS.GLOBAL_TRUST }
      ],
      answerKey: "movingConcierge"
    },
    {
      id: STEP_IDS.RENTER_MOVING_SOON_INTRO,
      type: "system",
      promptKey: "movingSoon.intro",
      next: STEP_IDS.RENTER_MOVING_DEALS
    },
    {
      id: STEP_IDS.RENTER_MOVING_DEALS,
      type: "singleChoice",
      promptKey: "movingSoon.dealsPrompt",
      options: [
        { id: "yes", labelKey: "yn.yes", next: STEP_IDS.RENTER_MOVING_RENTERS_INSURANCE },
        { id: "no", labelKey: "yn.no", next: STEP_IDS.RENTER_PHONE_TEXT }
      ],
      answerKey: "movingDeals"
    },
    {
      id: STEP_IDS.RENTER_MOVING_RENTERS_INSURANCE,
      type: "singleChoice",
      promptKey: "movingSoon.rentersInsurancePrompt",
      options: [
        { id: "yes", labelKey: "yn.yes", next: STEP_IDS.RENTER_PHONE_TEXT },
        { id: "no", labelKey: "yn.no", next: STEP_IDS.RENTER_PHONE_TEXT }
      ],
      answerKey: "movingRentersInsurance"
    },
    {
      id: STEP_IDS.RENTER_FIND_HOME_CONSENT,
      type: "singleChoice",
      promptKey: "findHome.consentPrompt",
      options: [
        { id: "yes", labelKey: "common.yes", next: STEP_IDS.RENTER_PHONE_TEXT },
        { id: "no", labelKey: "common.no", next: STEP_IDS.RENTER_PHONE_TEXT }
      ],
      answerKey: "findHomeConsent"
    },
    {
      id: STEP_IDS.RENTER_MOVE_IN,
      type: "text",
      promptKey: "findHome.moveInPrompt",
      fields: [
        { id: "moveInDate", labelKey: "findHome.moveInDate", inputType: "date", default: "firstOfNextMonth" }
      ],
      answerKey: "moveIn",
      next: STEP_IDS.RENTER_BUDGET
    },
    {
      id: STEP_IDS.RENTER_BUDGET,
      type: "slider",
      promptKey: "findHome.pricePrompt",
      slider: { min: 500, max: 5000, step: 50, default: 1500, unit: "USD" },
      answerKey: "price",
      next: STEP_IDS.RENTER_BEDROOMS
    },
    {
      id: STEP_IDS.RENTER_BEDROOMS,
      type: "singleChoice",
      promptKey: "findHome.bedroomsPrompt",
      options: [
        { id: "studio", labelKey: "findHome.bedroomsOptions.studio" },
        { id: "1", labelKey: "findHome.bedroomsOptions.one" },
        { id: "2", labelKey: "findHome.bedroomsOptions.two" },
        { id: "3", labelKey: "findHome.bedroomsOptions.three" },
        { id: "4_plus", labelKey: "findHome.bedroomsOptions.fourPlus" }
      ],
      answerKey: "bedrooms",
      next: STEP_IDS.RENTER_TARGET_CITY
    },
    {
      id: STEP_IDS.RENTER_MOVE_IN_IMPORTANCE,
      type: "singleChoice",
      promptKey: "findHome.moveInImportancePrompt",
      options: [
        { id: "4", labelKey: "findHome.moveInImportanceOptions.gottaMove" },
        { id: "2", labelKey: "findHome.moveInImportanceOptions.noHurry" },
        { id: "3", labelKey: "findHome.moveInImportanceOptions.flexible" },
        { id: "1", labelKey: "findHome.moveInImportanceOptions.justLooking" }
      ],
      answerKey: "moveInImportance",
      next: STEP_IDS.RENTER_LEASE_SIGNERS
    },
    {
      id: STEP_IDS.RENTER_LEASE_SIGNERS,
      type: "singleChoice",
      promptKey: "findHome.leaseSignersPrompt",
      options: [
        { id: "just_me", labelKey: "findHome.leaseSignersOptions.justMe" },
        { id: "partner", labelKey: "findHome.leaseSignersOptions.partner" },
        { id: "roommates", labelKey: "findHome.leaseSignersOptions.roommates" },
        { id: "cosigner", labelKey: "findHome.leaseSignersOptions.cosigner" }
      ],
      answerKey: "leaseSigners",
      next: STEP_IDS.RENTER_AMENITIES
    },
    {
      id: STEP_IDS.RENTER_TARGET_CITY,
      type: "singleChoice",
      promptKey: "findHome.txCityPrompt",
      options: [
        { id: "dallas", labelKey: "findHome.cities.dallas" },
        { id: "houston", labelKey: "findHome.cities.houston" },
        { id: "austin", labelKey: "findHome.cities.austin" },
        { id: "san_antonio", labelKey: "findHome.cities.san_antonio" },
        { id: "other", labelKey: "methods.other", isOther: true, otherPlaceholderKey: "methods.pleaseSpecify" }
      ],
      answerKey: "targetCity",
      next: STEP_IDS.RENTER_NAME_EMAIL
    },
    {
      id: STEP_IDS.RENTER_NAME_EMAIL,
      type: "text",
      promptKey: "findHome.nameEmailPrompt",
      fields: [
        { id: "name", labelKey: "findHome.nameLabel" },
        { id: "email", labelKey: "findHome.emailLabel", validateEmail: true }
      ],
      answerKey: "nameEmailDetails",
      next: (answers) => {
        const cityId = answers?.targetCity;
        // Skip neighborhoods step if "other" city was selected
        if (!cityId || cityId === "other" || cityId.startsWith("other:")) {
          return STEP_IDS.RENTER_PETS;
        }
        return STEP_IDS.RENTER_NEIGHBORHOODS;
      }
    },
    {
      id: STEP_IDS.RENTER_NEIGHBORHOODS,
      type: "multiChoice",
      promptKey: "findHome.neighborhoodsPrompt",
      options: (answers) => {
        const cityId = answers?.targetCity;
        // Should not reach here if "other" was selected, but handle gracefully
        if (!cityId || cityId === "other" || cityId.startsWith("other:")) {
          return [];
        }
        const market = CITY_TO_MARKET[cityId];
        if (!market || !NEIGHBORHOODS_BY_MARKET[market]) {
          return [];
        }
        // Create options from neighborhoods, using the neighborhood name as both id and label
        return NEIGHBORHOODS_BY_MARKET[market].map((neighborhood) => ({
          id: neighborhood,
          label: neighborhood
        }));
      },
      answerKey: "neighborhoods",
      next: STEP_IDS.RENTER_PETS
    },
    {
      id: STEP_IDS.RENTER_PETS,
      type: "singleChoice",
      promptKey: "findHome.petsPrompt",
      options: [
        { id: "yes", labelKey: "yn.yes" },
        { id: "no", labelKey: "yn.no" }
      ],
      answerKey: "hasPets",
      next: STEP_IDS.RENTER_MOVE_IN_IMPORTANCE
    },
    {
      id: STEP_IDS.RENTER_AMENITIES,
      type: "multiChoice",
      promptKey: "findHome.amenitiesPrompt",
      options: [
        { id: "attachedPrivateGarages", labelKey: "findHome.amenities.attachedPrivateGarages" },
        { id: "dogRun", labelKey: "findHome.amenities.dogRun" },
        { id: "evCharging", labelKey: "findHome.amenities.evCharging" },
        { id: "elevators", labelKey: "findHome.amenities.elevators" },
        { id: "fencedCommunity", labelKey: "findHome.amenities.fencedCommunity" },
        { id: "fencedYardsTx", labelKey: "findHome.amenities.fencedYardsTx" },
        { id: "petWash", labelKey: "findHome.amenities.petWash" },
        { id: "rooftopDeck", labelKey: "findHome.amenities.rooftopDeck" },
        { id: "wdConnections", labelKey: "findHome.amenities.wdConnections" },
        { id: "wdIncluded", labelKey: "findHome.amenities.wdIncluded" }
      ],
      answerKey: "amenities",
      next: STEP_IDS.RENTER_PARKING
    },
    {
      id: STEP_IDS.RENTER_PARKING,
      type: "singleChoice",
      promptKey: "findHome.parkingPrompt",
      options: [
        { id: "onSite", labelKey: "findHome.parking.onSite" },
        { id: "uncovered", labelKey: "findHome.parking.uncovered" },
        { id: "street", labelKey: "findHome.parking.street" },
        { id: "none", labelKey: "findHome.parking.none" }
      ],
      answerKey: "parkingPreference",
      next: STEP_IDS.RENTER_WHAT_MATTERS
    },
    {
      id: STEP_IDS.RENTER_WHAT_MATTERS,
      type: "singleChoice",
      promptKey: "findHome.whatMattersPrompt",
      options: [
        { id: "location", labelKey: "findHome.whatMatters.location" },
        { id: "price", labelKey: "findHome.whatMatters.price" },
        { id: "features", labelKey: "findHome.whatMatters.features" }
      ],
      answerKey: "whatMattersMost",
      next: STEP_IDS.RENTER_HOME_TYPE
    },
    {
      id: STEP_IDS.RENTER_HOME_TYPE,
      type: "singleChoice",
      promptKey: "findHome.homeTypePrompt",
      options: [
        { id: "apartment", labelKey: "findHome.homeType.apartment" },
        { id: "single_family", labelKey: "findHome.homeType.single_family" },
        { id: "both", labelKey: "findHome.homeType.both" }
      ],
      answerKey: "homeType",
      next: STEP_IDS.RENTER_CREDIT_SCORE
    },
    {
      id: STEP_IDS.RENTER_CREDIT_SCORE,
      type: "slider",
      promptKey: "findHome.creditPrompt",
      slider: { min: 300, max: 850, step: 10, default: 700, unit: "score" },
      answerKey: "creditScore",
      next: STEP_IDS.RENTER_FIND_HOME_FINAL
    },
    {
      id: STEP_IDS.RENTER_CONTACT_METHOD,
      type: "singleChoice",
      promptKey: "findHome.contactMethodPrompt",
      showPiiNotice: true,
      options: [
        { id: "text", labelKey: "findHome.contactMethodOptions.text", next: STEP_IDS.RENTER_PHONE_TEXT },
        { id: "call", labelKey: "findHome.contactMethodOptions.call", next: STEP_IDS.RENTER_PHONE_CALL },
        { id: "email", labelKey: "findHome.contactMethodOptions.email", next: STEP_IDS.RENTER_EMAIL }
      ],
      answerKey: "contactMethod"
    },
    {
      id: STEP_IDS.RENTER_PHONE_CALL,
      type: "text",
      promptKey: "findHome.phonePrompt",
      fields: [{ id: "phone", labelKey: "findHome.phoneLabel" }],
      answerKey: "phoneCallDetails",
      next: STEP_IDS.RENTER_MOVE_IN,
      showPiiNotice: true,
      requireConsent: true,
      consentKey: "findHome.phoneConsent"
    },
    {
      id: STEP_IDS.RENTER_PHONE_TEXT,
      type: "text",
      promptKey: "findHome.phonePrompt",
      fields: [{ id: "phone", labelKey: "findHome.phoneLabel" }],
      answerKey: "phoneTextDetails",
      next: STEP_IDS.RENTER_MOVE_IN,
      showPiiNotice: true,
      requireConsent: true,
      consentKey: "findHome.phoneConsent"
    },
    {
      id: STEP_IDS.RENTER_EMAIL,
      type: "text",
      promptKey: "findHome.emailPrompt",
      fields: [{ id: "email", labelKey: "findHome.emailLabel", validateEmail: true }],
      answerKey: "emailDetails",
      next: STEP_IDS.RENTER_MOVE_IN
    },
    {
      id: STEP_IDS.GLOBAL_TRUST,
      type: "system",
      next: (answers) => {
        if (answers?.identityMethod) return STEP_IDS.GLOBAL_END;
        // For renter, agent, just_learn, and owner personas, skip identity step and go straight to manual contact
        if (answers?.persona === "renter" || answers?.persona === "agent" || answers?.persona === "just_learn" || answers?.persona === "owner") {
          return STEP_IDS.GLOBAL_MANUAL_CONTACT;
        }
        return STEP_IDS.GLOBAL_IDENTITY;
      }
    },
    {
      id: STEP_IDS.GLOBAL_IDENTITY,
      type: "singleChoice",
      promptKey: "identity.prompt",
      showPiiNotice: true,
      options: [
        { id: "google", labelKey: "brand.googleCta" },
        { id: "manual", labelKey: "brand.enterManually" }
      ],
      answerKey: "identityMethod",
      next: (answers) => (answers.identityMethod === "manual" ? STEP_IDS.GLOBAL_MANUAL_CONTACT : STEP_IDS.GLOBAL_POST_IDENTITY_ROUTER)
    },
    {
      id: STEP_IDS.GLOBAL_MANUAL_CONTACT,
      type: "text",
      promptKey: "manual.prompt",
      showPiiNotice: true,
      fields: [
        { id: "name", labelKey: "manual.name" },
        { id: "email", labelKey: "manual.email", validateEmail: true },
        { id: "phone", labelKey: "manual.phone" }
      ],
      answerKey: "manualContact",
      next: (answers) => {
        // For agent persona, skip DOB and go straight to completion message
        if (answers?.persona === "agent") {
          return STEP_IDS.AGENT_CONTACT_COMPLETE;
        }
        // For owner persona, skip DOB and go straight to end
        if (answers?.persona === "owner") {
          return STEP_IDS.GLOBAL_END;
        }
        // For just_learn persona, skip DOB and go straight to end
        if (answers?.persona === "just_learn") {
          return STEP_IDS.GLOBAL_END;
        }
        return STEP_IDS.GLOBAL_DOB_CHECK;
      }
    },
    {
      id: STEP_IDS.GLOBAL_POST_IDENTITY_ROUTER,
      type: "system",
      promptKey: "router.silent",
      next: (answers) => {
        // For agent persona, skip all other flows and go to completion message
        if (answers?.persona === "agent") {
          return STEP_IDS.AGENT_CONTACT_COMPLETE;
        }
        // For owner persona, skip all other flows and go to end
        if (answers?.persona === "owner") {
          return STEP_IDS.GLOBAL_END;
        }
        // For just_learn persona, skip all other flows and go to end
        if (answers?.persona === "just_learn") {
          return STEP_IDS.GLOBAL_END;
        }
        const reasons = answers?.renterReasons ?? [];
        // For cashback flows, show greeting first, then route based on payment method
        if (reasons.includes("cashback")) {
          return STEP_IDS.GLOBAL_POST_IDENTITY_GREETING;
        }
        if (reasons.includes("credit")) return STEP_IDS.CREDIT_METHOD_FOLLOWUP;
        if (reasons.includes("find-home")) return STEP_IDS.RENTER_FIND_HOME_INTRO;
        return STEP_IDS.CASHBACK_METHOD_FOLLOWUP;
      }
    },
    {
      id: STEP_IDS.GLOBAL_POST_IDENTITY_GREETING,
      type: "system",
      promptKey: "cashback.postGoogleGreeting",
      promptParams: () => {
        try {
          const raw = (typeof window !== "undefined" && window.localStorage && window.localStorage.getItem("stake_ai_soft_signup")) || null;
          const stored = raw ? JSON.parse(raw) : {};
          const manual = stored?.manualContact?.name;
          const profGiven = stored?.profile?.given_name || stored?.profile?.givenName;
          const profName = stored?.profile?.name;
          const firstFromManual = manual ? (manual || "").split(" ")[0] : "";
          const firstFromProf = profGiven || (profName ? (profName || "").split(" ")[0] : "");
          const firstName = firstFromManual || firstFromProf || "";
          return { firstName, punct: firstName ? "." : "" };
        } catch {
          return { firstName: "", punct: "" };
        }
      },
      next: (answers) => {
        const reasons = answers?.renterReasons ?? [];
        if (reasons.includes("cashback")) {
          // Derive method from cashbackWherePayRent and cashbackHowPayRent
          const wherePayRent = answers?.cashbackWherePayRent ?? "";
          const howPayRent = answers?.cashbackHowPayRent ?? "";
          let method = "other";
          if (wherePayRent === "building-portal") {
            method = howPayRent === "card" ? "card" : "property-portal";
          } else if (wherePayRent === "landlord-direct") {
            method = howPayRent === "bank-account" ? "bank-routing" : "landlord-direct";
          }
          // Eligible methods (bank-routing, property-portal) go to phone input for bank setup
          // Non-eligible methods (card, landlord-direct, other) go to phone collection for future outreach
          const isEligible = method === "bank-routing" || method === "property-portal";
          if (isEligible) {
            return STEP_IDS.CASHBACK_PHONE_INPUT;
          }
          // Non-eligible methods go to phone collection
          return STEP_IDS.CASHBACK_PHONE_COLLECTION;
        }
        return STEP_IDS.CASHBACK_BANK_OCCUPATION;
      }
    },
    {
      id: STEP_IDS.CASHBACK_WHERE_PAY_RENT,
      type: "singleChoice",
      promptKey: "cashback.wherePayRentPrompt",
      options: [
        { id: "building-portal", labelKey: "cashback.wherePayRentOptions.buildingPortal", helperTextKey: "cashback.wherePayRentOptions.buildingPortalHelper" },
        { id: "landlord-direct", labelKey: "cashback.wherePayRentOptions.landlordDirect", helperTextKey: "cashback.wherePayRentOptions.landlordDirectHelper" },
        { id: "other", labelKey: "cashback.wherePayRentOptions.other" }
      ],
      answerKey: "cashbackWherePayRent",
      next: STEP_IDS.CASHBACK_HOW_PAY_RENT
    },
    {
      id: STEP_IDS.CASHBACK_HOW_PAY_RENT,
      type: "singleChoice",
      promptKey: "cashback.howPayRentPrompt",
      options: (answers) => {
        const wherePayRent = answers?.cashbackWherePayRent ?? "";
        if (wherePayRent === "building-portal") {
          return [
            { id: "bank-account", labelKey: "cashback.howPayRentOptions.bankAccount", helperTextKey: "cashback.howPayRentOptions.bankAccountHelper" },
            { id: "card", labelKey: "cashback.howPayRentOptions.card" },
            { id: "other", labelKey: "cashback.howPayRentOptions.other" }
          ];
        } else if (wherePayRent === "landlord-direct") {
          return [
            { id: "cash-check-venmo-zelle", labelKey: "cashback.howPayRentOptions.cashCheckVenmoZelle" },
            { id: "bank-account", labelKey: "cashback.howPayRentOptions.bankAccount", helperTextKey: "cashback.howPayRentOptions.bankAccountHelper" },
            { id: "card", labelKey: "cashback.howPayRentOptions.card" },
            { id: "other", labelKey: "cashback.howPayRentOptions.other" }
          ];
        } else {
          // "other" or unknown
          return [
            { id: "bank-account", labelKey: "cashback.howPayRentOptions.bankAccount", helperTextKey: "cashback.howPayRentOptions.bankAccountHelper" },
            { id: "card", labelKey: "cashback.howPayRentOptions.card" },
            { id: "cash-check-venmo-zelle", labelKey: "cashback.howPayRentOptions.cashCheckVenmoZelle" },
            { id: "other", labelKey: "cashback.howPayRentOptions.other", isOther: true, otherPlaceholderKey: "methods.pleaseSpecify" }
          ];
        }
      },
      answerKey: "cashbackHowPayRent",
      next: (answers) => {
        const wherePayRent = answers?.cashbackWherePayRent ?? "";
        const howPayRent = answers?.cashbackHowPayRent ?? "";
        // Eligible: building-portal + bank-account, building-portal + card (if they use portal)
        // Also eligible: landlord-direct + bank-account (if they pay landlord via ACH)
        const isEligible = 
          (wherePayRent === "building-portal" && (howPayRent === "bank-account" || howPayRent === "card")) ||
          (wherePayRent === "landlord-direct" && howPayRent === "bank-account");
        
        if (isEligible) {
          return STEP_IDS.CASHBACK_READY;
        }
        // Not eligible - collect phone for future outreach
        return STEP_IDS.CASHBACK_PHONE_COLLECTION;
      }
    },
    {
      id: STEP_IDS.CASHBACK_METHOD_PROMPT,
      type: "singleChoice",
      promptKey: "cashback.rentMethodPrompt",
      options: [
        { id: "bank-routing", labelKey: "methods.bankRouting" },
        { id: "property-portal", labelKey: "methods.propertyPortal" },
        { id: "card", labelKey: "methods.card" },
        { id: "landlord-direct", labelKey: "methods.landlordDirect" },
        { id: "other", labelKey: "methods.other", isOther: true, otherPlaceholderKey: "methods.pleaseSpecify" }
      ],
      answerKey: "cashbackRentMethod",
      next: (answers) => {
        const method = answers?.cashbackRentMethod ?? "";
        // First two options are eligible for cashback
        if (method === "bank-routing" || method === "property-portal") {
          return STEP_IDS.CASHBACK_READY;
        }
        // Other options are not eligible - collect phone for future outreach
        return STEP_IDS.CASHBACK_PHONE_COLLECTION;
      }
    },
    {
      id: STEP_IDS.CASHBACK_READY,
      type: "singleChoice",
      promptKey: "cashback.readyToJoin",
      options: [
        { id: "yes", labelKey: "yn.yes", next: STEP_IDS.CASHBACK_INTRO },
        { id: "no", labelKey: "yn.no", next: STEP_IDS.CASHBACK_READY_SELLDOWN }
      ],
      answerKey: "cashbackReadyToJoin",
      next: (answers) => (answers?.cashbackReadyToJoin === "yes" ? STEP_IDS.CASHBACK_INTRO : STEP_IDS.CASHBACK_READY_SELLDOWN)
    },
    {
      id: STEP_IDS.CASHBACK_INTRO,
      type: "system",
      promptKey: "intro.cashback",
      next: STEP_IDS.GLOBAL_MANUAL_CONTACT
    },
    {
      id: STEP_IDS.CREDIT_INTRO,
      type: "system",
      promptKey: "intro.credit",
      next: STEP_IDS.GLOBAL_MANUAL_CONTACT
    },
    {
      id: STEP_IDS.CASHBACK_READY_SELLDOWN,
      type: "singleChoice",
      promptKey: "cashback.accountSellDown",
      options: [
        { id: "ok_try_it", labelKey: "cashback.okTryIt", next: STEP_IDS.CASHBACK_INTRO },
        { id: "no_free_money", labelKey: "cashback.noFreeMoney", next: STEP_IDS.CASHBACK_READY_WHY }
      ],
      answerKey: "cashbackReadySellDown"
    },
    {
      id: STEP_IDS.CASHBACK_READY_WHY,
      type: "singleChoice",
      promptKey: "cashback.whyPrompt",
      options: [
        { id: "changed_mind", labelKey: "cashback.changedMind", next: STEP_IDS.CASHBACK_INTRO },
        { id: "other", labelKey: "cashback.whyOther", isOther: true, otherPlaceholderKey: "methods.pleaseSpecify" }
      ],
      answerKey: "cashbackReadyWhy",
      next: (answers) => {
        const why = answers?.cashbackReadyWhy;
        if (why === "changed_mind") {
          return STEP_IDS.CASHBACK_INTRO;
        }
        // For "other" option, the handleSingleOtherSubmit will handle routing to GLOBAL_END
        return STEP_IDS.GLOBAL_END;
      }
    },
    {
      id: STEP_IDS.CASHBACK_ACCOUNT_EXPLAINER,
      type: "singleChoice",
      promptKey: "cashback.accountExplainerPreDOB",
      promptParams: (answers) => {
        // Extract firstName from answers (manual contact) or Google profile in localStorage
        try {
          // First check answers for manual contact name
          const manualContact = answers?.manualContact || {};
          const nameFromAnswers = manualContact?.name || "";
          const firstFromAnswers = nameFromAnswers ? nameFromAnswers.trim().split(/\s+/)[0] : "";
          
          // Fall back to localStorage for Google profile or soft signup data
          const raw = (typeof window !== "undefined" && window.localStorage && window.localStorage.getItem("stake_ai_soft_signup")) || null;
          const stored = raw ? JSON.parse(raw) : {};
          const manual = stored?.manualContact?.name;
          const profGiven = stored?.profile?.given_name || stored?.profile?.givenName;
          const profName = stored?.profile?.name;
          const firstFromManual = manual ? (manual || "").split(" ")[0] : "";
          const firstFromProf = profGiven || (profName ? (profName || "").split(" ")[0] : "");
          
          const firstName = firstFromAnswers || firstFromManual || firstFromProf || "";
          return { firstName, punct: firstName ? "!" : "" };
        } catch {
          return { firstName: "", punct: "" };
        }
      },
      options: [
        { id: "yes", labelKey: "yn.yes", next: STEP_IDS.GLOBAL_DOB_CHECK },
        { id: "no", labelKey: "yn.no", next: STEP_IDS.CASHBACK_ACCOUNT_SELLDOWN }
      ],
      answerKey: "cashbackAccountConsent"
    },
    {
      id: STEP_IDS.CASHBACK_ACCOUNT_SELLDOWN,
      type: "singleChoice",
      promptKey: "cashback.accountSellDown",
      options: [
        { id: "ok_try_it", labelKey: "cashback.okTryIt", next: STEP_IDS.GLOBAL_DOB_CHECK },
        { id: "no_free_money", labelKey: "cashback.noFreeMoney", next: STEP_IDS.CASHBACK_ACCOUNT_WHY }
      ],
      answerKey: "cashbackAccountSellDown"
    },
    {
      id: STEP_IDS.CASHBACK_ACCOUNT_WHY,
      type: "singleChoice",
      promptKey: "cashback.whyPrompt",
      options: [
        { id: "changed_mind", labelKey: "cashback.changedMind", next: STEP_IDS.GLOBAL_DOB_CHECK },
        { id: "other", labelKey: "cashback.whyOther", isOther: true, otherPlaceholderKey: "methods.pleaseSpecify" }
      ],
      answerKey: "cashbackAccountWhy",
      next: (answers) => {
        const why = answers?.cashbackAccountWhy;
        if (why === "changed_mind") {
          return STEP_IDS.GLOBAL_DOB_CHECK;
        }
        // For "other" option, the handleSingleOtherSubmit will handle routing to GLOBAL_END
        return STEP_IDS.GLOBAL_END;
      }
    },
    {
      id: STEP_IDS.CASHBACK_PHONE_COLLECTION,
      type: "system",
      promptKey: "cashback.phoneCollectionPrompt",
      promptParams: (answers) => {
        // Derive method from cashbackWherePayRent and cashbackHowPayRent
        const wherePayRent = answers?.cashbackWherePayRent ?? "";
        const howPayRent = answers?.cashbackHowPayRent ?? "";
        let method = "other";
        if (wherePayRent === "building-portal") {
          method = howPayRent === "card" ? "card" : "property-portal";
        } else if (wherePayRent === "landlord-direct") {
          method = howPayRent === "bank-account" ? "bank-routing" : "landlord-direct";
        }
        let methodName = "";
        if (method === "bank-routing") methodName = "bank account & routing numbers";
        else if (method === "property-portal") methodName = "property website/app";
        else if (method === "card") methodName = "debit/credit card";
        else if (method === "landlord-direct") methodName = "landlord directly";
        else if (method.startsWith("other:")) {
          methodName = method.split(":").slice(1).join(":");
        }
        if (!methodName) methodName = "this method";
        return { method: methodName };
      },
      next: STEP_IDS.CASHBACK_PHONE_INPUT
    },
    {
      id: STEP_IDS.CASHBACK_PHONE_INPUT,
      type: "text",
      promptKey: "cashback.phonePrompt",
      fields: [{ id: "phone", labelKey: "findHome.phoneLabel" }],
      answerKey: "cashbackPhoneDetails",
      next: (answers) => {
        // Derive method from cashbackWherePayRent and cashbackHowPayRent
        const wherePayRent = answers?.cashbackWherePayRent ?? "";
        const howPayRent = answers?.cashbackHowPayRent ?? "";
        let method = "other";
        if (wherePayRent === "building-portal") {
          method = howPayRent === "card" ? "card" : "property-portal";
        } else if (wherePayRent === "landlord-direct") {
          method = howPayRent === "bank-account" ? "bank-routing" : "landlord-direct";
        }
        // Non-eligible methods go to phone thanks (end flow)
        // Eligible methods continue to DOB check for bank account setup
        const isEligible = method === "bank-routing" || method === "property-portal";
        if (isEligible) {
        return STEP_IDS.GLOBAL_DOB_CHECK;
        }
        // Non-eligible methods end with phone thanks
        return STEP_IDS.CASHBACK_PHONE_THANKS;
      }
    },
    {
      id: STEP_IDS.CASHBACK_BANK_OCCUPATION,
      type: "singleChoice",
      promptKey: "bank.occupationPrompt",
      options: (UnitOccupationList || []).map((o) => ({
        id: String(o.value ?? o.id ?? o.label).toLowerCase().replace(/[^a-z0-9]+/gi, "").trim(),
        labelKey: `bank.occupations.${String(o.value ?? o.id ?? o.label)}`
      })),
      answerKey: "bankOccupation",
      next: STEP_IDS.CASHBACK_BANK_ADDRESS
    },
    {
      id: STEP_IDS.GLOBAL_DOB_CHECK,
      type: "text",
      promptKey: "bank.dobPrompt",
      fields: [{ id: "dob", labelKey: "bank.dobLabel", inputType: "date" }],
      answerKey: "bankDOB",
      next: (answers) => {
        // Routing is handled in ChatEngine based on user existence check
        // For cashback flows, route to occupation after DOB (account explainer already shown before DOB for new users)
        const reasons = answers?.renterReasons ?? [];
        if (reasons.includes("cashback")) {
          // ChatEngine will override based on API response (new user vs existing user)
          // Default to occupation, but ChatEngine will handle 2FA flow for existing users
          return STEP_IDS.CASHBACK_BANK_OCCUPATION;
        }
        // For non-cashback flows, route to occupation
        return STEP_IDS.CASHBACK_BANK_OCCUPATION;
      }
    },
    {
      id: STEP_IDS.CASHBACK_BANK_ADDRESS,
      type: "text",
      promptKey: "bank.addressPrompt",
      fields: [{ id: "address", labelKey: "bank.addressLabel", placeholder: "Enter your home address", inputType: "address" }],
      answerKey: "bankAddress",
      next: STEP_IDS.CASHBACK_BANK_SSN
    },
    {
      id: STEP_IDS.CASHBACK_BANK_SSN,
      type: "text",
      promptKey: "bank.ssnPrompt",
      fields: [{ id: "ssn", labelKey: "bank.ssnLabel" }],
      answerKey: "bankSSN",
      next: STEP_IDS.CASHBACK_BANK_PRICING
    },
    {
      id: STEP_IDS.CASHBACK_BANK_PRICING,
      type: "singleChoice",
      promptKey: "bank.pricingMessage",
      options: [{ id: "makesSense", labelKey: "bank.makesSense", next: STEP_IDS.CASHBACK_BANK_DISCLOSURES }],
      answerKey: "pricingAcknowledged",
      next: STEP_IDS.CASHBACK_BANK_DISCLOSURES
    },
    {
      id: STEP_IDS.CASHBACK_BANK_DISCLOSURES,
      type: "singleChoice",
      promptKey: "bank.onlineDisclosuresPrompt",
      agreementsIntroKey: "legal.agreementsIntro",
      agreements: [
        { id: "consent", labelKey: "legal.agreements.consentElectronic", url: "https://getyourstake.com/legal/consent-to-electronic-disclosures" },
        { id: "stakeDeposit", labelKey: "legal.agreements.stakeDeposit", url: "https://getyourstake.com/legal/stake-consumer-deposit-account-agreement-disclosures" },
        { id: "transpecosDeposit", labelKey: "legal.agreements.transpecosDeposit", url: "https://disclosures.transpecos.bank/terms/stake/consumerdepositaccountagreement.pdf" }
      ],
      options: [{ id: "agree", labelKey: "legal.agreeToAll" }],
      answerKey: "bankDisclosureConsent",
      // Navigation is handled in ChatEngine - API call triggers and navigates away
      next: STEP_IDS.GLOBAL_END
    },
    {
      id: STEP_IDS.CASHBACK_BANK_FINAL,
      type: "system",
      promptKey: "bank.finalMessage",
      next: STEP_IDS.GLOBAL_END
    },
    {
      id: STEP_IDS.CASHBACK_2FA_REQUEST,
      type: "system",
      promptKey: "router.silent",
      next: STEP_IDS.CASHBACK_2FA_VERIFY
    },
    {
      id: STEP_IDS.CASHBACK_2FA_VERIFY,
      type: "text",
      promptKey: "bank.2FAVerifyPrompt",
      fields: [{ id: "code", labelKey: "bank.2FACodeLabel" }],
      answerKey: "twoFactorCode",
      next: (answers) => {
        // For cashback flows, route to account explainer after 2FA verification
        // ChatEngine will handle the actual routing based on user status
        return STEP_IDS.CASHBACK_ACCOUNT_EXPLAINER;
      }
    },
    {
      id: STEP_IDS.RETURNING_USER_GREETING,
      type: "system",
      promptKey: "cashback.returningUserGreeting",
      promptParams: () => {
        try {
          const raw = (typeof window !== "undefined" && window.localStorage && window.localStorage.getItem("stake_ai_soft_signup")) || null;
          const stored = raw ? JSON.parse(raw) : {};
          const manual = stored?.manualContact?.name;
          const profGiven = stored?.profile?.given_name || stored?.profile?.givenName;
          const profName = stored?.profile?.name;
          const firstFromManual = manual ? (manual || "").split(" ")[0] : "";
          const firstFromProf = profGiven || (profName ? (profName || "").split(" ")[0] : "");
          const firstName = firstFromManual || firstFromProf || "";
          return { firstName, punct: firstName ? "." : "" };
        } catch {
          return { firstName: "", punct: "" };
        }
      },
      next: STEP_IDS.CASHBACK_BANK_OCCUPATION
    },
    {
      id: STEP_IDS.CASHBACK_PHONE_THANKS,
      type: "system",
      promptKey: "cashback.phoneThanks",
      next: STEP_IDS.GLOBAL_END
    },
    {
      id: STEP_IDS.CASHBACK_METHOD_FOLLOWUP,
      type: "singleChoice",
      promptKey: "cashback.thanksFlow",
      options: [
        { id: "zelle", labelKey: "methods.zelle" },
        { id: "venmo", labelKey: "methods.venmo" },
        { id: "property-portal", labelKey: "methods.portal" },
        { id: "ach", labelKey: "methods.ach" },
        { id: "other", labelKey: "methods.other", isOther: true, otherPlaceholderKey: "methods.pleaseSpecify" }
      ],
      answerKey: "rentPayMethod",
      next: STEP_IDS.GLOBAL_END
    },
    {
      id: STEP_IDS.CREDIT_METHOD_FOLLOWUP,
      type: "singleChoice",
      promptKey: "credit.thanksFlow",
      options: [
        { id: "zelle", labelKey: "methods.zelle" },
        { id: "venmo", labelKey: "methods.venmo" },
        { id: "property-portal", labelKey: "methods.portal" },
        { id: "ach", labelKey: "methods.ach" },
        { id: "other", labelKey: "methods.other", isOther: true, otherPlaceholderKey: "methods.pleaseSpecify" }
      ],
      answerKey: "rentPayMethod",
      next: STEP_IDS.GLOBAL_END
    },
    {
      id: STEP_IDS.RENTER_FIND_HOME_INTRO,
      type: "system",
      promptKey: "findHome.intro",
      next: STEP_IDS.GLOBAL_END
    },
    {
      id: STEP_IDS.RENTER_FIND_HOME_FINAL,
      type: "system",
      promptKey: "findHome.finalMessage",
      next: STEP_IDS.GLOBAL_END
    },
    {
      id: STEP_IDS.AGENT_TRUST,
      type: "system",
      promptKey: "trust.agent",
      next: STEP_IDS.GLOBAL_MANUAL_CONTACT
    },
    {
      id: STEP_IDS.OWNER_TRUST,
      type: "system",
      promptKey: "trust.owner",
      next: STEP_IDS.GLOBAL_MANUAL_CONTACT
    },
    {
      id: STEP_IDS.OWNER_MOM_POP_TRUST,
      type: "system",
      promptKey: "trust.owner",
      next: STEP_IDS.GLOBAL_MANUAL_CONTACT
    },
    {
      id: STEP_IDS.OWNER_LARGE_TRUST,
      type: "system",
      promptKey: "trust.owner",
      next: STEP_IDS.GLOBAL_MANUAL_CONTACT
    },
    {
      id: STEP_IDS.LEARN_TRUST,
      type: "system",
      promptKey: "trust.message",
      next: STEP_IDS.GLOBAL_MANUAL_CONTACT
    },
    {
      id: STEP_IDS.AGENT_CONTACT_COMPLETE,
      type: "system",
      promptKey: "agent.contactComplete"
    },
    {
      id: STEP_IDS.GLOBAL_END,
      type: "system",
      promptKey: "saved"
    }
  ]
};



